// extracted by mini-css-extract-plugin
export default {"timeTableSlot":"TimeTableSlot_timeTableSlot__fBYr1","timeTableSlot__body":"TimeTableSlot_timeTableSlot__body__sl+sU"};